import React from "react";

import { useTranslation } from "react-i18next";

import { getMuiPopupContainer } from "../../../../container/themes/dispatchTheme";
import { Comment } from "../../../../models/comment";
import Modal from "../../Modal";
import CommentForm from "../Form";
import CommentHistory from "../History";
import useStyles from "./styles";

interface Props {
  comment?: Comment;
  comments?: Comment[];
  count?: number;
  hasMore?: boolean;
  isLoadingCreate?: boolean;
  isLoadingHistory?: boolean;
  onClose: () => void;
  onLoadMore: () => void;
  onSubmit: (comment: Comment) => void;
  open: boolean;
  placeholderText?: string;
  title?: string;
  maxCommentLength?: number;
  onDeleteComment?: (data: Comment) => void;
  hasPermission?: boolean;
}

const CommentsModal = ({
  comment = {},
  comments = [],
  count = 0,
  hasMore = false,
  isLoadingCreate = false,
  isLoadingHistory = false,
  onClose,
  onLoadMore,
  onSubmit,
  open,
  placeholderText,
  maxCommentLength,
  title,
  onDeleteComment,
  hasPermission = true,
}: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <Modal
      container={getMuiPopupContainer}
      className={classes.modal}
      handleClose={onClose}
      open={open}
      showModalBodyScroll={false}
      showModalFooter={false}
      title={title || translate("newComment")}
    >
      <CommentForm
        comment={comment}
        isLoading={isLoadingCreate}
        maxLength={maxCommentLength || 500}
        onSubmit={onSubmit}
        placeholderText={placeholderText}
        hasPermission={hasPermission}
      />
      <div className={classes.historyContainer}>
        <CommentHistory
          comments={comments}
          count={count}
          hasMore={hasMore}
          isLoading={isLoadingHistory}
          onLoadMore={onLoadMore}
          onDeleteComment={onDeleteComment}
          hasPermission={hasPermission}
        />
      </div>
    </Modal>
  );
};

export default CommentsModal;
